<template>
    <div class="skeleton-box" ></div>
  </template>
  
  <script>
  export default {

  };
  </script>
  
  <style scoped>
  .skeleton-box {
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #fff 25%, #f0f0f0 50%, #f9f9f9 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
    border-radius: 4px;
  }
  
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
  </style>